import React, { useEffect } from "react";
import PropTypes from "prop-types";
import FacilityWarrantyCard from "./FacilityWarrantyCard";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { loadFacilityWarranties } from "../../actionCreators";
import { getFacilityWarranties } from "../../selectors";

const FacilityWarrantyContainer = ({ documentId, siteId }) => {
  const dispatch = useDispatch();

  const {
    content: facilityWarranties,
    loading: facilityWarrantiesLoading,
    loaded: facilityWarrantiesLoaded
  } = useSelector(state => getFacilityWarranties(documentId, state), shallowEqual);

  useEffect(() => {
    if (facilityWarrantiesLoading || facilityWarrantiesLoaded) return;
    if (documentId !== null && documentId !== undefined && siteId !== null && siteId !== undefined)
      dispatch(loadFacilityWarranties(documentId, siteId));
  }, [facilityWarrantiesLoading, facilityWarrantiesLoaded, documentId, siteId, dispatch]);

  return (
    <FacilityWarrantyCard
      facilityWarranties={facilityWarranties}
      loading={facilityWarrantiesLoading}
      Loaded={facilityWarrantiesLoaded}
    />
  );
};

FacilityWarrantyContainer.propTypes = {
  documentId: PropTypes.number,
  siteId: PropTypes.number
};

export default FacilityWarrantyContainer;
